import { ApolloError } from '@apollo/client/core';
import { Action, createActionGroup, emptyProps, props } from '@ngrx/store';
import { JobDetailsV2Fragment, ResolveServiceAreaQuery, } from 'graphql.generated';
import { LocationType } from 'src/app/global.constants';

import { AccessType, ElevatorType } from 'src/app/job/job-overview/overview-locations/overview-locations.state';

import { ActionSource } from '../../../state/action-sources';

import { LocationWithHowSetIndicator } from '../../job-tool.reducer';

export const JobCreateLocationsActions = createActionGroup({
	source: ActionSource.JOB_CREATE_LOCATIONS,
	events: {
		'Google Autocomplete Input Changed': props<{
			address: string;
			locationType: string;
		}>(),
		'Google Autocomplete Address Selected': props<{
			address: google.maps.places.PlaceResult;
			locationType: string;
		 }>(),
		'Unit Number Entered': props<{
      unitNumber: string;
			locationType: LocationType;
		}>(),
		'Building Type Selected': props<{
			buildingType: string;
			locationType: LocationType;
		}>(),
		'Size Selected': props<{
			size: string;
			locationType: LocationType;
		}>(),
		'Access Selected': props<{
			access: AccessType;
			locationType: LocationType;
		}>(),
		'Show Google Maps Route Button Clicked': props<{
			locations: LocationWithHowSetIndicator;
		}>(),
		'Add Location Manually Button Clicked': props<{
			locationType: string;
		}>(),
		'Add Stop Button Clicked': emptyProps(),
		'Additional Location Type Selected': props<{
			previousLocationType: LocationType;
			newLocationType: LocationType;
		}>(),
		'Remove Additional Location Button Clicked': props<{
			locationType: LocationType;
		}>(),
		'Update Locations Success': props<{
			updatedJob: JobDetailsV2Fragment;
      customSuccessMessage?: string;
		}>(),
		'Update Locations Error': props<{
      error: ApolloError;
      customErrorMessage?: string;
    }>(),
		'Set Service Area Button clicked': emptyProps(),
		'Resolve Service Area Success': props<{ responseData: ResolveServiceAreaQuery['resolveServiceArea'] }>(),
		'Resolve Service Area Error': props<{ error: ApolloError }>(),
    'Job Locations Loaded': props<{ job: JobDetailsV2Fragment; promptedBy: Action }>(),
    'Header Clicked': emptyProps(),
    'Elevator Type Selected': props<{ elevatorType: ElevatorType; locationType: LocationType; }>(),
    'Floor Input Changed': props<{ floor: number; locationType: LocationType; }>(),
    'Access Notes Text Area Content Changed': props<{ accessNotes: string; locationType: LocationType; }>(),
	},
});
